import request from '@/utils/http.js';
import qs from 'qs';


// 获取AI报告的数据
export function getReportInfo ( options ) {
	return request( {
		url: `${ window.config.api_v1 }/report/getReportInfo`,
		method: 'GET',
		params: options
	} );
}

//   AI报告分享数据切片
export function shareReport ( options ) {
	return request( {
		url: `${ window.config.api_v1 }/open/shareReport`,
		method: 'GET',
		params: options
	} );
}

// AI报告2.0数据切片 shareReportTow
export function shareReportTow ( options ) {
	return request( {
		url: `${ window.config.api_v1 }/open/shareReportTow`,
		method: 'POST',
    	data: qs.stringify(options)
	} );
}

// 获取AI报告的数据
export function getReportRedisById ( options ) {
	return request( {
		url: `${ window.config.api_v1 }/report/getReportRedisById`,
		method: 'GET',
		params: options
	} );
}

// 获取AI报告2.0数据
export function backtestAiReport ( options ) {
	return request( {
		url: `${ window.config.api_v1 }/report/backtestAiReport`,
		method: 'GET',
		params: options
	} );
}
